
import { StateCreator } from 'zustand';
import { UserState } from './userState';
import { authActions } from './authActions';
import { User } from '@/types/user';
import { AuthUser } from '@/contexts/auth/types/AuthTypes';

export type { UserState } from './userState';
export { setupAuthListeners } from './authListeners';

/**
 * Creates the user slice for the Zustand store
 */
export const createUserSlice: StateCreator<
  UserState, 
  [], 
  [], 
  UserState
> = (set, get) => ({
  user: null,
  isLoading: false,
  isAuthenticated: false,
  
  // Initialize auth
  initAuth: async () => await authActions.initAuth(set, get),
  
  // Login - correzione del tipo di ritorno
  login: async (email: string, password: string) => {
    await authActions.login(set, get, email, password);
    return get().user; // Ritorna l'utente corrente dopo il login
  },
  
  // Logout
  logout: async () => await authActions.logout(set, get),
  
  // Register - correzione del tipo di ritorno
  register: async (email: string, password: string, name: string) => {
    await authActions.register(set, get, email, password, name);
    return get().user; // Ritorna l'utente corrente dopo la registrazione
  },
  
  // Set user - adattamento AuthUser -> User richiesto nello store
  setUser: (user) => {
    // Se l'utente è nullo, passiamo null direttamente
    if (!user) {
      return authActions.setUser(set, get, null);
    }
    
    // Altrimenti creiamo un oggetto User compatibile a partire da AuthUser
    const adaptedUser: User = {
      id: user.id,
      email: user.email,
      name: user.name,
      role: user.role,
      role_name: (user.role || 'USER') as 'USER' | 'DEALER' | 'ADMIN' | 'SUPER_ADMIN',
      dealer_activation_status: user.dealer_activation_status as 'NONE' | 'PENDING' | 'APPROVED' | 'REJECTED',
      avatar_url: user.profile?.avatarUrl
    };
    
    return authActions.setUser(set, get, adaptedUser);
  },
  
  // Sync the store with the auth context
  syncWithAuthContext: (authUser, isAuthenticated, isLoading) => {
    console.log("[userSlice] Syncing with auth context:", { 
      hasUser: !!authUser, 
      userId: authUser?.id,
      isAuthenticated,
      isLoading
    });
    
    // Aggiorniamo lo stato in base ai dati ricevuti dal contesto di autenticazione
    if (isAuthenticated && authUser) {
      // Utente autenticato
      set({
        user: authUser,
        isAuthenticated: true,
        isLoading: isLoading
      });
      
      console.log("[userSlice] Auth state updated: User authenticated");
    } else {
      // Utente non autenticato o dati mancanti
      set({
        user: null,
        isAuthenticated: false,
        isLoading: isLoading
      });
      
      console.log("[userSlice] Auth state updated: User not authenticated");
    }
  }
});
